import React from 'react';
import { Field } from 'redux-form';

import styles from './ModifierOptionsField.css';

const ModifierInputWithoutValidation = props => {
  return (
    <div className="form-group">
      <input type="text" {...props} {...props.input} />
    </div>
  );
};

const ModifierOptionsField = props => {
  const { member, onDelete } = props;
  return (
    <div className="mk-grouped-input">
      <div className="form-group col-sm-6">
        <Field
          name={`${member}.name`}
          component={ModifierInputWithoutValidation}
          className="form-control"
          placeholder="Name"
        />
      </div>
      <div className="form-group col-sm-5">
        <Field
          name={`${member}.price`}
          component={ModifierInputWithoutValidation}
          positiveNumberOnly
          maxFractionDigits={3}
          placeholder="Rp. 0"
          onChange={e => {
            if (isNaN(e.target.value)) {
              e.preventDefault();
            }
          }}
          className="form-control"
        />
      </div>
      <div className="col-sm-1" style={{ marginTop: '7px' }}>
        <span
          className={`${styles['btn-delete']}`}
          onClick={onDelete}
          type="button"
        >
          <i className="fa fa-times-circle" />
        </span>
      </div>
    </div>
  );
};

export default ModifierOptionsField;
